<script setup>
import { useAuthStore } from '@/store/auth.store';

//--------- barLeft click  ----------
	const barLeft = () => {
		const leftBar = document.querySelector('.leftbar');
		const topBar = document.querySelector('.topbar');
		const dashboard = document.querySelector('.dashboard');
		leftBar.classList.add('leftbar--active')
		topBar.classList.add('topbar--active')
		dashboard.classList.add('dashboard--active')
	}
//----------barLeft mouse leve------
	const barLeave = () => {
		const leftBar = document.querySelector('.leftbar');
		const topBar = document.querySelector('.topbar');
		const dashboard = document.querySelector('.dashboard');
		leftBar.classList.remove('leftbar--active')
		topBar.classList.remove('topbar--active')
		dashboard.classList.remove('dashboard--active')
	}
//---------barLeft nav dropdown-----
	const navItemList = (event) => {
		const parentItem = event.currentTarget.closest('.nav__item');
		if (parentItem) {
			parentItem.classList.toggle('nav__item--active');
		}
	};

	const authSotre = useAuthStore();

</script>

<template>
	<div class="leftbar" @mouseenter="barLeft()" @mouseleave="barLeave()">

		<div class="leftbar__svg">
			<svg version="1.1" id="leftBarLogo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 184 53" enable-background="new 0 0 184 53" xml:space="preserve">
			<g>
				<defs>
					<rect id="SVGID_1_" y="0.4" width="184" height="52"/>
				</defs>
				<clipPath id="SVGID_2_">
					<use xlink:href="#SVGID_1_"  overflow="visible"/>
				</clipPath>
				<g clip-path="url(#SVGID_2_)">
					<g id="lLeftText">
						<path fill="#0963AD" d="M0,33.4V15.5h10.6v4.3H4.9v2.7h5.1v4.1H4.9v6.8H0z"/>
						<path fill="#0963AD" d="M17.1,14.6h-4.4v18.8h4.4V14.6z"/>
						<path fill="#0963AD" d="M26.6,33.8c-1.5,0-2.8-0.3-3.9-0.8c-1.1-0.6-1.9-1.3-2.5-2.3c-0.6-1-0.9-2.2-0.9-3.5c0-2,0.6-3.6,1.9-4.8
							c1.3-1.2,3.1-1.8,5.3-1.8c1.5,0,2.8,0.3,3.9,0.8c1.1,0.6,1.9,1.3,2.5,2.3c0.6,1,0.9,2.2,0.9,3.4c0,1.3-0.3,2.5-0.9,3.5
							c-0.6,1-1.4,1.8-2.5,2.3C29.4,33.5,28.1,33.8,26.6,33.8z M26.6,30.6c0.9,0,1.6-0.3,2-1c0.5-0.6,0.7-1.5,0.7-2.5
							c0-1-0.2-1.8-0.7-2.4c-0.5-0.6-1.1-1-2-1c-0.9,0-1.6,0.3-2,1c-0.5,0.6-0.7,1.5-0.7,2.4c0,1,0.2,1.8,0.7,2.5
							C25,30.3,25.7,30.6,26.6,30.6z"/>
						<path fill="#0963AD" d="M42.7,33.8c-1.5,0-2.8-0.3-3.9-0.8c-1.1-0.6-1.9-1.3-2.5-2.3c-0.6-1-0.9-2.2-0.9-3.5c0-2,0.6-3.6,1.9-4.8
							c1.3-1.2,3.1-1.8,5.3-1.8c1.5,0,2.8,0.3,3.9,0.8c1.1,0.6,1.9,1.3,2.5,2.3c0.6,1,0.9,2.2,0.9,3.4c0,1.3-0.3,2.5-0.9,3.5
							c-0.6,1-1.4,1.8-2.5,2.3C45.5,33.5,44.2,33.8,42.7,33.8z M42.7,30.6c0.9,0,1.6-0.3,2-1c0.5-0.6,0.7-1.5,0.7-2.5
							c0-1-0.2-1.8-0.7-2.4c-0.5-0.6-1.1-1-2-1c-0.9,0-1.6,0.3-2,1c-0.5,0.6-0.7,1.5-0.7,2.4c0,1,0.2,1.8,0.7,2.5
							C41.1,30.3,41.7,30.6,42.7,30.6z"/>
						<path fill="#0963AD" d="M61,22.3v-7.7h4.4v18.8h-4.2v-1.5c-1,1.3-2.3,1.9-4,1.9c-1.1,0-2.1-0.3-3-0.9c-0.9-0.6-1.5-1.4-2-2.4
							c-0.5-1-0.7-2.1-0.7-3.4c0-1.2,0.2-2.3,0.7-3.3c0.4-1,1.1-1.8,1.9-2.4c0.9-0.6,1.9-0.9,3.1-0.9c0.8,0,1.6,0.1,2.1,0.4
							C59.9,21.3,60.4,21.7,61,22.3z M58.7,30.1c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.6,0.9-1.1c0.2-0.4,0.3-0.9,0.3-1.5
							c0-0.8-0.2-1.5-0.7-2.1c-0.5-0.6-1.1-0.8-1.9-0.8c-0.9,0-1.6,0.3-2,0.9c-0.4,0.6-0.6,1.3-0.6,2c0,0.8,0.2,1.5,0.6,2.1
							C57.1,29.8,57.8,30.1,58.7,30.1z"/>
						<path fill="#0E9FDA" d="M69.3,33.4l6.3-17.9h6l6.3,17.9h-5.3l-1-3.1h-6l-1,3.1H69.3z M78.6,19.7l-2,6.6h4L78.6,19.7z"/>
						<path fill="#0E9FDA" d="M93.9,14.6h-4.4v18.8h4.4V14.6z"/>
						<path fill="#0E9FDA" d="M109,29.6c-0.4,1.2-1.1,2.2-2.2,3c-1,0.8-2.5,1.2-4.4,1.2c-1,0-2-0.2-2.8-0.5c-0.8-0.3-1.6-0.8-2.1-1.4
							c-0.6-0.6-1-1.3-1.4-2.1c-0.3-0.8-0.5-1.7-0.5-2.7c0-1.4,0.3-2.6,0.9-3.6c0.6-1,1.4-1.8,2.4-2.3c1-0.5,2.2-0.8,3.4-0.8
							c1.6,0,2.9,0.4,3.9,1.1c1,0.7,1.7,1.7,2.1,2.8c0.4,1.1,0.6,2.4,0.6,3.7h-9.3c0,0.5,0.1,1,0.3,1.4c0.2,0.5,0.5,0.8,0.9,1.1
							c0.4,0.3,0.9,0.4,1.5,0.4c0.6,0,1.2-0.1,1.6-0.4c0.4-0.3,0.7-0.6,0.8-1.1H109z M99.9,25.7h4.9c0-0.6-0.3-1.2-0.7-1.7
							c-0.4-0.5-1-0.8-1.8-0.8c-0.8,0-1.3,0.3-1.8,0.8C100.2,24.5,99.9,25.1,99.9,25.7z"/>
						<path fill="#0E9FDA" d="M115,22.6c0.5-0.7,1-1.2,1.7-1.5c0.6-0.3,1.2-0.4,1.8-0.4c0.1,0,0.5,0,1.1,0.1v3.9
							c-0.3-0.1-0.7-0.2-1.1-0.2c-0.7,0-1.2,0.1-1.7,0.4c-0.5,0.3-0.9,0.7-1.1,1.2c-0.3,0.5-0.4,1.2-0.4,1.9v5.3h-4.4V21h4.2V22.6z"/>
						<path fill="#0E9FDA" d="M122.5,33.4v-9.1h-1.6V21h1.6v-3.4h4.4V21h2.5v3.2h-2.5v9.1H122.5z"/>
					</g>
					<g id="lRightText">
						<path fill="#0963AD" d="M158.4,52.1c14.1,0,25.6-11.6,25.6-25.9S172.5,0.4,158.4,0.4c-14.1,0-25.6,11.6-25.6,25.9
							S144.3,52.1,158.4,52.1z"/>
						<path fill-rule="evenodd" clip-rule="evenodd" fill="#0C81C4" d="M134.7,36c4.4-3.6,9.9-5.7,16-5.7c10.7,0,19.9,6.7,23.7,16.2
							c-4.4,3.6-9.9,5.7-16,5.7C147.7,52.1,138.5,45.5,134.7,36z"/>
						<path fill-rule="evenodd" clip-rule="evenodd" fill="#0E9FDA" d="M175.8,45.2c-4.6,4.3-10.7,6.9-17.4,6.9s-12.8-2.6-17.4-6.9
							c4.6-4.3,10.7-6.9,17.4-6.9S171.2,40.9,175.8,45.2z"/>
						<path fill-rule="evenodd" clip-rule="evenodd" fill="#0E9FDA" fill-opacity="0.8" d="M182.8,33.8c-1.8,6-5.9,11.4-11.7,14.8
							c-5.8,3.4-12.4,4.2-18.5,2.9c1.8-6,5.9-11.4,11.7-14.8C170.2,33.3,176.8,32.4,182.8,33.8z"/>
						<path fill="#FFFFFF" d="M144.4,27.3h-0.5V25h0.5c0.4,0,0.9-0.1,1.2-0.3c0.4-0.2,0.6-0.6,0.6-1.2c0-0.6-0.2-1-0.5-1.2
							s-0.7-0.3-1.1-0.3c-0.5,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.5,0.6-0.5,1.1h-4c0.1-0.8,0.4-1.5,0.8-2.2c0.4-0.7,1-1.2,1.8-1.6
							c0.8-0.4,1.9-0.6,3.2-0.6c1,0,1.9,0.1,2.8,0.4c0.8,0.3,1.5,0.7,2,1.3c0.5,0.6,0.7,1.3,0.7,2.1c0,0.8-0.2,1.4-0.6,1.9
							c-0.4,0.5-1,0.8-1.7,1v0.1c0.8,0.2,1.4,0.6,2,1.1c0.6,0.6,0.9,1.4,0.9,2.5c0,0.9-0.3,1.7-0.8,2.4c-0.5,0.7-1.3,1.2-2.2,1.5
							c-0.9,0.3-2,0.5-3.1,0.5c-1.5,0-2.7-0.3-3.6-0.8c-0.9-0.5-1.5-1.2-1.8-1.9c-0.3-0.7-0.5-1.5-0.6-2.1h4c0,0.5,0.1,0.9,0.4,1.3
							c0.3,0.4,0.8,0.6,1.6,0.6c1.3,0,2-0.6,2-1.9c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.5-0.4-0.8-0.4C145.1,27.4,144.7,27.3,144.4,27.3z"/>
						<path fill="#FFFFFF" d="M157.7,19.4h4.7l-3.9,4.9c0.4-0.1,0.9-0.2,1.3-0.2c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.6,1.7
							c0.4,0.7,0.6,1.5,0.6,2.3c0,1-0.3,1.9-0.8,2.6c-0.5,0.8-1.2,1.4-2.2,1.8c-1,0.4-2,0.6-3.3,0.6c-1.1,0-2.2-0.2-3.1-0.6
							c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.8-0.8-1.7-0.8-2.8c0-0.8,0.1-1.6,0.4-2.3c0.3-0.7,0.7-1.5,1.4-2.3L157.7,19.4z M158.3,30.8
							c0.7,0,1.3-0.2,1.7-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.6-0.6c-0.7,0-1.2,0.2-1.6,0.6
							c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5C157.1,30.6,157.7,30.8,158.3,30.8z"/>
						<path fill="#FFFFFF" d="M172.1,33.8c-1.7,0-3-0.4-3.9-1.3c-0.9-0.8-1.5-1.8-1.8-2.9c-0.3-1.1-0.4-2.2-0.4-3.3
							c0-1.1,0.1-2.2,0.4-3.3c0.3-1.1,0.9-2,1.8-2.9c0.9-0.8,2.2-1.3,3.9-1.3c1.7,0,3,0.4,3.9,1.3c0.9,0.8,1.5,1.8,1.8,2.9
							c0.3,1.1,0.4,2.2,0.4,3.2c0,1.8-0.4,3.5-1.2,5.1C176.2,33,174.6,33.8,172.1,33.8z M172.1,30.8c0.6,0,1-0.2,1.3-0.6
							s0.5-0.9,0.6-1.6c0.1-0.6,0.1-1.4,0.1-2.3c0-0.9,0-1.6-0.1-2.3s-0.3-1.2-0.6-1.6c-0.3-0.4-0.7-0.6-1.3-0.6c-0.6,0-1,0.2-1.3,0.6
							c-0.3,0.4-0.5,0.9-0.6,1.6c-0.1,0.6-0.1,1.4-0.1,2.3c0,0.9,0,1.7,0.1,2.3c0.1,0.6,0.3,1.1,0.6,1.6
							C171.1,30.6,171.5,30.8,172.1,30.8z"/>
					</g>
				</g>
			</g>
			</svg>
		</div>

		<ul class="nav">
			<li class="nav__item">
				<router-link to="/dashboard" 
					class="nav__item_block" 
					:class="{ 'nav__item_block--active': $route.path === '/dashboard' }"
				>
					<span class="material-symbols-outlined">dashboard_customize</span>
					<p>My Dashboard</p>
				</router-link>
			</li>
			<li v-if="authSotre.user?.permissions.subscriberList || authSotre.user?.permissions.admin" class="nav__item">
				<router-link to="/subscriber" class="nav__item_block" 
					:class="{ 'nav__item_block--active': 
						$route.path === '/subscriber' ||
						$route.path === '/subscriber-profile' 
					}">
					<span class="material-symbols-outlined">person</span>
					<p>Subscriber List</p>
				</router-link>
			</li>
      <li v-if="authSotre.user?.permissions.analytics || authSotre.user?.permissions.admin" class="nav__item nav__item-list">
				<div 
					@click="navItemList($event)" 
					class="nav__item_block nav__item_dropdown"
					:class="{ 'nav__item_block--active':
						$route.path === '/reports-shipping' ||
						$route.path === '/reports-shipping-all' ||
						$route.path === '/reports-shipping-in-transit' ||
						$route.path === '/reports-shipping-running-late' ||
						$route.path === '/reports-shipping-issue' ||
						$route.path === '/reports-shipping-delivered' || 
						$route.path === '/reports-activity'
					}"
				>
					<span class="material-symbols-outlined">finance</span>
					<p>Analytics & Reports</p>
				</div>
				<ul class="nav__item_list">
					<router-link
						to="/reports-shipping"
						class="nav__item_block"
						:class="{ 'nav__item_block--active':
							$route.path === '/reports-shipping' ||
							$route.path === '/reports-shipping-all' ||
							$route.path === '/reports-shipping-in-transit' ||
							$route.path === '/reports-shipping-running-late' ||
							$route.path === '/reports-shipping-issue' ||
							$route.path === '/reports-shipping-delivered'
						}">
						<span class="material-symbols-outlined">local_shipping</span>
						<p>Shipping and Fulfillment</p>
					</router-link>
					<router-link
						to="/reports-activity"
						class="nav__item_block"
						:class="{ 'nav__item_block--active': $route.path === '/reports-activity' }">
						<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8334 12.7677V11.8703C13.8334 11.7955 13.8094 11.7341 13.7613 11.686C13.7132 11.6379 13.6517 11.6139 13.577 11.6139H2.42317C2.34837 11.6139 2.28693 11.6379 2.23885 11.686C2.19077 11.7341 2.16672 11.7955 2.16672 11.8703V12.7677H13.8334ZM11.4905 10.3639L11.1603 9.37833C11.139 9.32491 11.1069 9.28349 11.0641 9.25416C11.0215 9.22474 10.9734 9.21008 10.92 9.21008H5.08018C5.02677 9.21008 4.97869 9.22474 4.93596 9.25416C4.89322 9.28349 4.86117 9.32491 4.83979 9.37833L4.50967 10.3639H11.4905ZM10.92 7.96008C11.2436 7.96008 11.5366 8.05433 11.799 8.24291C12.0612 8.43149 12.2452 8.68066 12.351 8.99049L12.8077 10.3639H13.577C13.9925 10.3639 14.3475 10.5111 14.6419 10.8054C14.9362 11.0997 15.0834 11.4547 15.0834 11.8703V14.0177H0.916748V11.8703C0.916748 11.4547 1.06392 11.0997 1.35827 10.8054C1.6526 10.5111 2.00757 10.3639 2.42317 10.3639H3.19237L3.74207 8.93924C3.85638 8.65183 4.03907 8.41683 4.29015 8.23408C4.5412 8.05141 4.82432 7.96008 5.1395 7.96008H10.92Z" fill="#334155"/><path d="M7.48964 3.98558L10.5714 0.895835C10.6953 0.766568 10.8425 0.699793 11.0128 0.695518C11.1832 0.691243 11.3331 0.753743 11.4624 0.883018C11.5917 1.01228 11.6563 1.16078 11.6563 1.32852C11.6563 1.49625 11.5917 1.64475 11.4624 1.77402L8.01687 5.21952C7.86623 5.37016 7.69049 5.44548 7.48964 5.44548C7.2888 5.44548 7.11306 5.37016 6.96241 5.21952L5.26689 3.52402C5.14296 3.40008 5.08181 3.25373 5.08341 3.08493C5.08501 2.91613 5.15045 2.76976 5.27972 2.64583C5.40364 2.53045 5.55001 2.47196 5.71881 2.47035C5.88761 2.46875 6.03397 2.52992 6.15789 2.65385L7.48964 3.98558Z" fill="#334155"/></svg>
						<p>Alarms Activity</p>
					</router-link>
<!--					<router-link-->
<!--						to="/reports-subscribers"-->
<!--						class="nav__item_block"-->
<!--						:class="{ 'nav__item_block&#45;&#45;active': $route.path === '/reports-subscribers' }">-->
<!--						<svg width="13" height="14" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--							<path d="M2.42268 14.6744C2.00173 14.6744 1.64543 14.5286 1.35376 14.2369C1.06209 13.9453 0.91626 13.589 0.91626 13.168V2.01423C0.91626 1.59329 1.06209 1.23698 1.35376 0.945313C1.64543 0.653646 2.00173 0.507812 2.42268 0.507812H10.5332C10.7341 0.507812 10.9272 0.546813 11.1125 0.624813C11.2979 0.702799 11.459 0.810167 11.5957 0.946917L14.6438 3.99498C14.7805 4.13173 14.8879 4.29279 14.9659 4.47817C15.0439 4.66353 15.0829 4.85663 15.0829 5.05748V13.168C15.0829 13.589 14.9371 13.9453 14.6454 14.2369C14.3537 14.5286 13.9974 14.6744 13.5765 14.6744H2.42268ZM2.42268 13.4245H13.5765C13.6513 13.4245 13.7127 13.4004 13.7608 13.3523C13.8089 13.3043 13.8329 13.2428 13.8329 13.168V5.09113H11.2528C11.038 5.09113 10.8588 5.01928 10.7151 4.87558C10.5714 4.73189 10.4996 4.55267 10.4996 4.33792V1.75779H2.42268C2.34788 1.75779 2.28645 1.78183 2.23836 1.82992C2.19028 1.878 2.16624 1.93944 2.16624 2.01423V13.168C2.16624 13.2428 2.19028 13.3043 2.23836 13.3523C2.28645 13.4004 2.34788 13.4245 2.42268 13.4245Z" fill="#0F172A"/>-->
<!--							<path d="M7.9995 7.41662C7.44807 7.41662 6.97602 7.22029 6.58333 6.82761C6.19065 6.43492 5.9943 5.96287 5.9943 5.41144C5.9943 4.86001 6.19065 4.38796 6.58333 3.99528C6.97602 3.60259 7.44807 3.40625 7.9995 3.40625C8.55092 3.40625 9.02298 3.60259 9.41566 3.99528C9.80835 4.38796 10.0047 4.86001 10.0047 5.41144C10.0047 5.96287 9.80835 6.43492 9.41566 6.82761C9.02298 7.22029 8.55092 7.41662 7.9995 7.41662ZM3.70264 10.9092V10.506C3.70264 10.2254 3.77884 9.96557 3.93126 9.7265C4.08366 9.48742 4.2873 9.30361 4.54217 9.17506C5.10848 8.89742 5.67975 8.68919 6.25597 8.55037C6.83219 8.41155 7.41337 8.34214 7.9995 8.34214C8.58563 8.34214 9.16681 8.41155 9.74303 8.55037C10.3192 8.68919 10.8905 8.89742 11.4568 9.17506C11.7117 9.30361 11.9153 9.48742 12.0677 9.7265C12.2202 9.96557 12.2964 10.2254 12.2964 10.506V10.9092C12.2964 11.1509 12.2117 11.3563 12.0424 11.5256C11.8731 11.6949 11.6676 11.7796 11.426 11.7796H4.57301C4.33136 11.7796 4.12589 11.6949 3.9566 11.5256C3.78729 11.3563 3.70264 11.1509 3.70264 10.9092ZM4.562 10.9202H11.437V10.506C11.437 10.3899 11.4034 10.2825 11.3362 10.1837C11.269 10.0849 11.1777 10.0043 11.0624 9.94187C10.5688 9.69875 10.0655 9.51457 9.5525 9.38933C9.03949 9.2641 8.52183 9.20149 7.9995 9.20149C7.47717 9.20149 6.9595 9.2641 6.44649 9.38933C5.93348 9.51457 5.43019 9.69875 4.9366 9.94187C4.82128 10.0043 4.73002 10.0849 4.66282 10.1837C4.5956 10.2825 4.562 10.3899 4.562 10.506V10.9202ZM7.9995 6.55728C8.3146 6.55728 8.58435 6.44508 8.80874 6.22069C9.03313 5.9963 9.14533 5.72655 9.14533 5.41144C9.14533 5.09634 9.03313 4.82659 8.80874 4.6022C8.58435 4.37781 8.3146 4.26561 7.9995 4.26561C7.68439 4.26561 7.41465 4.37781 7.19025 4.6022C6.96586 4.82659 6.85366 5.09634 6.85366 5.41144C6.85366 5.72655 6.96586 5.9963 7.19025 6.22069C7.41465 6.44508 7.68439 6.55728 7.9995 6.55728Z" fill="#0F172A"/>-->
<!--						</svg>-->
<!--						<p>Subscribers</p>-->
<!--					</router-link>-->
<!--					<router-link-->
<!--						to="/reports-claims"-->
<!--						class="nav__item_block"-->
<!--						:class="{ 'nav__item_block&#45;&#45;active':-->
<!--							$route.path === '/reports-claims' ||-->
<!--							$route.path === '/reports-claims-account'-->
<!--						 }">-->
<!--						<span class="material-symbols-outlined">water_damage</span>-->
<!--						<p>Claims</p>-->
<!--					</router-link>-->
				</ul>
			</li>
			<li v-if="authSotre.user?.permissions.marketing || authSotre.user?.permissions.admin" class="nav__item">
				<router-link 
					to="/marketing" 
					class="nav__item_block" 
					:class="{ 'nav__item_block--active': 
						$route.path === '/marketing' || 
						$route.path === '/marketing-link' || 
						$route.path === '/marketing-patterns' || 
						$route.path === '/marketing-gallery'
					}">
					<span class="material-symbols-outlined">link</span>
					<p>Marketing Page</p>
				</router-link>
			</li>
			<li v-if="authSotre.user?.permissions.manageTeam || authSotre.user?.permissions.admin" class="nav__item">
				<router-link 
				to="/team" 
				class="nav__item_block" 
				:class="{ 'nav__item_block--active':
				 	$route.name === 'my-team' ||
					$route.name === 'user-profile'
				}">
					<span class="material-symbols-outlined">groups</span>
					<p>Team Management</p>
				</router-link>
			</li>
			<li v-if="!authSotre.user?.group && (authSotre.user?.permissions.manageAllCompanies || authSotre.user?.permissions.admin)" class="nav__item">
				<router-link 
				to="/companies" 
				class="nav__item_block" 
				:class="{ 'nav__item_block--active':
				 $route.name === 'companies' ||
				 $route.name === 'company-team'
				 }">
					<span class="material-symbols-outlined">corporate_fare</span>
					<p>Companies</p>
				</router-link>
			</li>
			<li v-if="authSotre.user.group && (authSotre.user?.permissions.сompanyProfile || authSotre.user?.permissions.admin)" class="nav__item">
				<router-link 
				:to="'/company/'" 
				class="nav__item_block" 
				:class="{ 'nav__item_block--active':
				 $route.name === 'company'
				 }">
					<span class="material-symbols-outlined">corporate_fare</span>
					<p>Company</p>
				</router-link>
			</li>
		</ul>

	</div>
</template>

<style lang="scss" scoped>
	.leftbar{
		position: fixed;
		top: 0;
		left: 0;
		overflow: hidden;
		padding: 20px 0;
		width: 80px;
		height: calc(100vh);
		box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
		background: #fff;
		transition: all .6s;
		z-index: 101;
	}
	.leftbar #lLeftText{
		opacity: 0;
		transition: all .6s;
	}
	.leftbar p {
		opacity: 0;
	}
	.leftbar__svg{
		width: 185px;
		height: 50px;
		margin-left: -120px;
		margin-bottom: 20px;
		transition: all .6s;
		cursor: pointer;
	}
	.leftbar__svg svg {
		width: 100%;
	}
	.leftbar--active {
		width: 260px;
	}
	.leftbar--active #lLeftText {
		opacity: 1;
	}
	.leftbar--active .leftbar__svg {
		margin-left: 30px;
	}
	.leftbar--active p {
		opacity: 1;
	}
	.leftbar--active .nav__item_dropdown:before {
		right: 12px;
	}

	.nav {
		display: flex;
		flex-direction: column;
		gap: 5px;
	}
	.nav__item--active .nav__item_list {
		display: flex;
	}
	.nav__item-list {
		flex-direction: column;
	}
	.nav__item svg {
		width: 23px;
		height: 19px;
	}

	.nav__item_dropdown {
		position: relative;
	}
	.nav__item_dropdown:before {
		content: '';
		position: absolute;
		right: 190px;
		top: 50%;
		transform: translate(0, -50%);
		width: 0;
		height: 0;
		border: 0 solid transparent;
		border-left-width: 4px;
		border-right-width: 4px;
		border-top: 4px solid black;
		transition: all .6s;
		cursor: pointer;
	}
	.nav__item_dropdown:hover:before {
		border-top: 4px solid#60A5FA;
	}
	// .nav__item--active .nav__item_dropdown {
	// 	color: #2563EB !important;
	// }
	// .nav__item--active .nav__item_dropdown:after {
	// 	opacity: 1;
	// 	background-color: #2563EB !important;
	// }
	.nav__item--active .nav__item_dropdown:before {
		transform: rotate(-180deg);
	}

	.nav__item--visited .nav__item_dropdown {
		color: #2563EB !important;
	}
	.nav__item--visited .nav__item_dropdown:after {
		opacity: 1;
		background-color: #2563EB !important;
	}
	.nav__item--visited .nav__item_dropdown:before {
		border-top: 4px solid #2563EB;
	}

	.nav__item-list .nav__item_list a{
		font-size: 14px ;
	}

	.nav__item-list .nav__item_list span{
		font-size: 20px ;
	}

	.nav__item_block {
		width: 260px;
		position: relative;
		padding: 10px 15px 10px 25px;
		display: flex;
		align-items: center;
		gap: 12px;
		cursor: pointer;
		color: #000;
		text-decoration: none;
		font-size: 16px;
		font-weight: 500;
		transition: all .3s;
	}
	.nav__item_block:after,
	.nav__item_dropdown:after {
		content: '';
		position: absolute;
		left: -2px;
		top: -2px;
		width: 6px;
		height: 100%;
		border-bottom-right-radius: 5px;
		border-top-right-radius: 5px;
		background: #2563EB;
		opacity: 0;
		transition: all .3s !important;
	}
	.nav__item_block:hover {
		color: #60A5FA;
	}
	.nav__item_block path {
		transition: all .3s !important;
	}
	.nav__item_block:hover span path {
		fill: #60A5FA;
	}
	.nav__item_block:hover:after {
		opacity: 1;
		left: -2px;
		background-color: #60A5FA;
	}
	.nav__item_block--active {
		color: #2563EB !important;
	}
	.nav__item_block--active path {
		fill: #2563EB !important;
	}
	.nav__item_block--active:after {
		content: '';
		position: absolute;
		left: -2px;
		top: -2px;
		width: 6px;
		height: 100%;
		border-bottom-right-radius: 5px;
		border-top-right-radius: 5px;
		background: #2563EB !important;
		opacity: 1;
		transition: all .3s;
	}

	.nav__item_list{
		flex-direction: column;
		display: none;
	}

</style>